export const PRODUCT_SPECS = {
  "gps-etrex": {
    resumen: "GPS de mano clásico de Garmin, sencillo, resistente y con pilas AA, para no perderte aunque no haya señal de celular.",
    ideal: ["Senderismo y montaña", "Pesca y navegación", "Geocaching"],
    specs: [
      ["Pantalla", '2.2" monocromática 128×160 px'],
      ["Satélites", "GPS + GLONASS"],
      ["Batería", "2 pilas AA, hasta 25 h"],
      ["Resistencia", "Contra agua IPX7"],
      ["Memoria", "1,000 waypoints, 100 tracks, 50 rutas"],
      ["Mapa", "Base mundial precargado"],
      ["Tamaño", "5.4 × 10.3 × 3.3 cm"],
      ["Peso", "142 g con pilas"],
    ],
  },
  "garmin-striker-4": {
    resumen: "Ecosonda compacta con GPS integrado para ver peces y estructura y marcar tus mejores puntos.",
    ideal: ["Lancha o kayak", "Pesca en presa y lago", "Pesca en hielo"],
    specs: [
      ["Pantalla", '3.5" a color 480×320 px'],
      ["Sonda", "CHIRP"],
      ["GPS", "Hasta 5,000 waypoints"],
      ["Funciones", "Fish Symbol ID, modo flasher"],
      ["Alimentación", "12 V"],
      ["Resistencia", "IPX7"],
      ["Peso", "230 g aprox."],
    ],
  },
  "garmin-striker-vivid-5cv": {
    resumen: 'Ecosonda de 5" con colores vivos y sonda ClearVü que muestra el fondo casi como una foto. Incluye GPS.',
    ideal: ["Lancha o kayak", "Pesca de lobina y mojarra", "Encontrar estructura"],
    specs: [
      ["Pantalla", '5" a color 800×480 px, 7 paletas'],
      ["Transductor", "GT20-TM incluido"],
      ["Sonda", "CHIRP tradicional + ClearVü"],
      ["Frecuencias", "50/77/200 kHz y 260/455/800 kHz"],
      ["Potencia", "500 W RMS"],
      ["GPS", "5,000 waypoints, 100 rutas, 50 tracks"],
      ["Sensor", "Temperatura del agua"],
      ["Alimentación", "12 a 20 V"],
      ["Resistencia", "IPX7"],
      ["Tamaño/peso", "18.8 × 11.6 × 5.4 cm, 0.5 kg"],
    ],
  },
  "kayak-1": {
    resumen: "Kayak de pesca sit-on-top Vibe, estable, con timón de pie y mucho espacio para tu equipo.",
    ideal: ["Pesca en mar, lago o río tranquilo", "Jornadas largas", "1 persona"],
    specs: [
      ["Largo", "3.5 m (11'6\")"],
      ["Ancho", "84 cm"],
      ["Peso del casco", "28 kg aprox."],
      ["Capacidad", "Hasta 193 kg"],
      ["Asiento", "Vibe Hero Seat 2.0, dos alturas"],
      ["Timón", "Controlado con los pies"],
      ["Pesca", "2 portacañas, rieles para accesorios, puerto para transductor"],
      ["Almacenamiento", 'Escotilla frontal 20", consola central con bolsas'],
    ],
  },
  "kayak-2": {
    resumen: "Kayak de pesca sit-on-top de 10 pies, ligero para cargar, muy estable y con portacañas y rieles.",
    ideal: ["Pesca y recreo", "Primer kayak de pesca", "1 persona"],
    specs: [
      ["Largo", "3.05 m (10')"],
      ["Ancho", "83 cm"],
      ["Peso del casco", "23 kg"],
      ["Capacidad", "Hasta 170 kg"],
      ["Asiento", "Vibe Hero Seat de malla"],
      ["Pesca", "4 portacañas, 2 rieles, 2 portacharolas"],
      ["Almacenamiento", "2 escotillas selladas con bolsa"],
      ["Extras", "Reposapiés ajustables, portavasos, 4 asas"],
    ],
  },
  "bocina-flip-6": {
    resumen: "Bocina JBL portátil del tamaño de una botella, resistente al agua y al polvo.",
    ideal: ["Camping y playa", "Río y alberca", "Llevar a todos lados"],
    specs: [
      ["Batería", "Hasta 12 h"],
      ["Resistencia", "IP67"],
      ["Bluetooth", "5.1"],
      ["Conectar varias", "PartyBoost"],
      ["Carga", "USB-C"],
      ["Tamaño", "17.8 × 6.8 × 7.2 cm"],
      ["Peso", "0.55 kg"],
    ],
  },
  "bocina-flip-7": {
    resumen: "La Flip más nueva de JBL: más potencia, sumergible IP68 y resistente a caídas de 1 m.",
    ideal: ["Río, playa y alberca", "Camping", "Bicicleta y mochila"],
    specs: [
      ["Potencia", "35 W"],
      ["Batería", "Hasta 14 h (16 h con Playtime Boost)"],
      ["Carga", "2.5 h USB-C"],
      ["Resistencia", "IP68, caídas de 1 m"],
      ["Bluetooth", "5.4 con Auracast"],
      ["Tamaño", "18.3 × 7.0 × 7.2 cm"],
      ["Peso", "0.83 kg"],
    ],
  },
  "bocina-charge-5": {
    resumen: "Bocina JBL con 20 h de batería que también carga tu celular.",
    ideal: ["Camping de varios días", "Fiestas al aire libre", "Cargar el celular"],
    specs: [
      ["Potencia", "40 W"],
      ["Batería", "Hasta 20 h, 7,500 mAh"],
      ["Carga", "4 h USB-C"],
      ["Powerbank", "Sí"],
      ["Resistencia", "IP67"],
      ["Bluetooth", "5.1"],
      ["Conectar varias", "PartyBoost"],
      ["Tamaño", "22.3 × 9.7 × 9.4 cm"],
      ["Peso", "0.96 kg"],
    ],
  },
  "bocina-charge-6": {
    resumen: "La Charge más nueva: más potencia, sumergible IP68, resistente a caídas y con powerbank.",
    ideal: ["Camping de varios días", "Río y playa", "Cargar el celular"],
    specs: [
      ["Potencia", "45 W"],
      ["Batería", "Hasta 24 h (28 h con Playtime Boost)"],
      ["Carga", "3 h, 10 min = 2.5 h de música"],
      ["Powerbank", "Sí"],
      ["Resistencia", "IP68, caídas de 1 m"],
      ["Bluetooth", "5.4 con Auracast"],
      ["Tamaño", "22.9 × 9.9 × 9.4 cm"],
      ["Peso", "1.37 kg"],
    ],
  },
  "drone-2": {
    resumen: "Dron plegable y ligero con GPS y regreso automático. Incluye control con pantalla propia de 4.3 pulgadas, así que no necesitas usar tu celular para ver lo que graba.",
    ideal: ["Viajes y paisajes", "Tomas aéreas de tus salidas", "Principiantes"],
    specs: [
      ["GPS", "Con retorno automático al punto de despegue"],
      ["Cámara", "Dual 8K con ajuste de ángulo"],
      ["Control", 'Con pantalla integrada de 4.3"'],
      ["Baterías", "2 incluidas"],
      ["Peso", "Menos de 250 g"],
      ["Diseño", "Plegable"],
      ["Funciones", "Seguimiento de trayectoria desde la app"],
      ["Color", "Gris"],
      ["Incluye", "Dron, control, 2 baterías, hélices de repuesto, cable de carga y estuche"],
    ],
  },
  "casa-camping": {
    resumen: "Casa de campaña ligera de 1 kg para hasta 3 personas, con mosquitero y cubre techo impermeable. Fácil de llevar y armar.",
    ideal: ["Camping de fin de semana", "Festivales y playa", "2 a 3 personas"],
    specs: [
      ["Marca", "Garselay"],
      ["Capacidad", "Hasta 3 personas"],
      ["Medidas", "2 × 1.5 m · 1.45 m de alto"],
      ["Peso", "1 kg"],
      ["Impermeabilidad", "1,500 mm · recubrimiento PU"],
      ["Resistencia al viento", "Hasta 30 km/h"],
      ["Paredes / piso", "Poliéster / polietileno"],
      ["Incluye", "Mosquitero y cubre techo"],
      ["Color", "Azul acero"],
    ],
  },
  "velocimetro": {
    resumen: "Velocímetro de bici con pantalla táctil retroiluminada y 19 funciones. Resistente a la lluvia y fácil de instalar.",
    ideal: ["Bici de ruta o montaña", "Medir tus recorridos", "Entrenar"],
    specs: [
      ["Pantalla", "LED táctil con luz de fondo"],
      ["Funciones", "19: velocidad actual, promedio y máxima, distancia, kilometraje total, tiempo, calorías, temperatura y reloj"],
      ["Conexión", "Sensor magnético con cable de 1.5 m"],
      ["Batería", "Pila CR2032"],
      ["Resistencia", "Contra agua (IPX6)"],
      ["Ahorro de energía", "Se apaga solo y se enciende al pedalear"],
      ["Compatible", "Bici de ruta, montaña y plegable"],
      ["Material", "ABS"],
      ["Tamaño / peso", "6 × 4.5 × 2 cm · 80 g"],
      ["Incluye", "Sensor, imán, 5 cinchos, silicona antideslizante y manual"],
    ],
  },
  "896d79cf-9bb4-4fb2-97cd-5f2bbf2b5810": {
    resumen: "Mochila deportiva de 40 L, a prueba de agua y reforzada, con compartimento para laptop y 6 bolsillos. Ligera para viajes, gimnasio o salidas al aire libre.",
    ideal: ["Senderismo y viajes", "Gimnasio y diario", "Llevar tu laptop"],
    specs: [
      ["Marca", "Videng King"],
      ["Capacidad", "40 L"],
      ["Medidas", "53 × 30 × 19 cm"],
      ["Peso", "500 g"],
      ["Material", "Nylon de alta calidad, reforzado y a prueba de agua"],
      ["Bolsillos", "6, incluye bolsillo para botella"],
      ["Laptop", "Compartimento acolchado"],
      ["Comodidad", "Correa de pecho"],
      ["Extras", "Salida para audífonos"],
      ["Color", "Negro"],
    ],
  },
  "24ed7ead-5a3c-4785-8d80-2e6640886263": {
    resumen: "Pulsera de supervivencia 5 en 1: lleva siempre contigo cuerda, brújula, silbato, pedernal y sierra.",
    ideal: ["Senderismo y camping", "Kit de emergencia", "Regalo para aventureros"],
    specs: [
      ["Cuerda", "Paracord de 3.2 m · resiste hasta 280 kg"],
      ["Brújula", "Para ubicarte fácilmente"],
      ["Silbato", "Para avisos de emergencia"],
      ["Pedernal", "Para encender fuego de forma sencilla"],
      ["Sierra", "Para cortar y hacer yesca"],
    ],
  },
  "casa-camping-2": {
    resumen: "Casa de campaña para hasta 4 personas que se arma sola en un minuto gracias a su sistema automático. Resiste la lluvia y trae mosquitero para dormir tranquilo.",
    ideal: ["Familias", "Grupos pequeños", "Fines de semana", "Principiantes"],
    specs: [
      ["Capacidad", "Hasta 4 personas"],
      ["Medidas", "210 x 215 cm"],
      ["Armado", "Automático, en 1 minuto"],
      ["Impermeabilidad", "3,000 mm (protege de la lluvia)"],
      ["Material", "Poliéster 190T ignífugo (resistente al fuego)"],
      ["Mosquitero", "Incluido"],
    ],
  },
  "bicicleta-r29": {
    resumen: "Bicicleta de montaña rodada 29 con doble suspensión, 21 velocidades Shimano y frenos de disco adelante y atrás. Lista para brecha, montaña y ciudad.",
    ideal: ["Montaña", "Brecha", "Ciudad", "Personas de 1.70 a 2.10 m"],
    specs: [
      ["Modelo", "Mercurio DS Kaizer 29"],
      ["Rodado", "29"],
      ["Velocidades", "21, cambios Shimano"],
      ["Frenos", "Disco mecánico delantero y trasero"],
      ["Suspensión", "Doble (delantera y central)"],
      ["Cuadro", "Acero"],
      ["Rines", "Aluminio"],
      ["Altura recomendada", "1.70 a 2.10 m"],
      ["Peso máximo", "120 kg"],
      ["Peso de la bici", "19.6 kg"],
      ["Incluye", "Manual de ensamblado"],
    ],
  },
  "drone-1": {
    resumen: "Dron profesional con GPS y motor brushless para un vuelo más estable. Trae 3 baterías para sesiones largas y cámara dual 8K con ajuste electrónico. Es el más completo de nuestros drones.",
    ideal: ["Video profesional", "Sesiones largas", "Inspección aérea", "Uso comercial"],
    specs: [
      ["Modelo", "Mini Y98 Ourlife"],
      ["GPS", "Sí, con retorno automático al punto de despegue"],
      ["Motor", "Brushless (sin escobillas), más estable y duradero"],
      ["Cámara", "Dual 8K con ajuste electrónico de ángulo"],
      ["Control", "Con pantalla e indicador de GPS"],
      ["Baterías", "3 incluidas, mayor autonomía total"],
      ["Incluye", "Dron, control, 3 baterías, hélices de repuesto y estuche rígido con accesorios"],
    ],
  },
  "bateria-solar-portatil": {
    resumen: "Batería portátil de 10,000 mAh con panel solar de emergencia, cables integrados y linterna. Resistente al agua, al polvo y a los golpes.",
    ideal: ["Camping", "Senderismo", "Viajes", "Emergencias"],
    specs: [
      ["Capacidad", "10,000 mAh"],
      ["Carga", "Por USB y por panel solar (respaldo de emergencia)"],
      ["Cables integrados", "USB-C, Lightning y Micro USB"],
      ["Salidas", "USB-A y USB-C"],
      ["Linterna", "LED con modo normal, SOS y estroboscópico"],
      ["Extras", "Brújula integrada y mosquetón"],
      ["Resistencia", "Agua, polvo y golpes"],
      ["Sirve para", "Celulares, audífonos, relojes inteligentes, tablets y cámaras compactas"],
      ["Nota", "La carga solar es un respaldo de emergencia; para carga completa usa USB."],
    ],
  },
  "centro-de-carga": {
    resumen: "Estación de energía portátil de 300 W con panel solar. Tiene tomas de corriente como las de tu casa para cargar laptops o conectar una TV de 32 pulgadas o un ventilador en campamentos y apagones.",
    ideal: ["Camping", "Viajes", "Emergencias y apagones", "Iluminación"],
    specs: [
      ["Potencia", "300 W"],
      ["Carga", "Con panel solar o corriente"],
      ["Tomas de corriente", "2 tomas AC"],
      ["Salidas", "USB-A, USB-C y DC"],
      ["Luz", "LED integrada"],
      ["Diseño", "Portátil con asa"],
      ["Puede conectar", 'TV de hasta 32", ventiladores, laptops y luces LED'],
      ["Sirve para cargar", "Laptops, drones, cámaras, radios y GPS"],
    ],
  },
  "bocina-boombox-4": {
    resumen: "La bocina portátil más potente de JBL, graves profundos, sumergible y con powerbank.",
    ideal: ["Fiestas y reuniones", "Campamentos en grupo", "Playa"],
    specs: [
      ["Potencia", "Hasta 210 W con cable"],
      ["Batería", "Hasta 28 h (34 h con Playtime Boost)"],
      ["Carga", "3 h"],
      ["Powerbank", "Sí"],
      ["Resistencia", "IP68"],
      ["Bluetooth", "5.4 con Auracast"],
      ["Tamaño", "51 × 26 × 21 cm"],
      ["Peso", "5.9 kg"],
    ],
  },
  "casa-camping-3": {
    resumen: "Casa de campaña gigante para hasta 16 personas, de armado automático. Tela Oxford impermeable con cubre techo, 4 ventanas y 2 puertas para que esté fresca y sea fácil entrar y salir. Ideal para familias grandes y grupos.",
    ideal: ["Familias grandes y grupos", "Campamentos y retiros", "Festivales y eventos"],
    specs: [
      ["Capacidad", "Hasta 16 personas"],
      ["Medidas", "4.20 × 3.05 m · 2 m de alto"],
      ["Tela", "Oxford 210D impermeable"],
      ["Impermeabilidad", "2,000 mm, se mantiene seca con lluvia fuerte"],
      ["Resistencia al viento", "Hasta 20 km/h"],
      ["Ventilación", "4 ventanas y 2 puertas"],
      ["Armado", "Automático, rápido y sencillo"],
      ["Incluye", "Cubre techo para protección extra contra el clima"],
    ],
  },
  "3974ebb0-a5d7-4275-8be3-178679c51415": {
    resumen: "Zapatillas de ciclismo de montaña con ajuste de rueda giratoria para un calce firme y rápido, y suela antideslizante para caminar con seguridad fuera de la bici.",
    ideal: ["Ciclismo de montaña (MTB)", "Rodadas de ruta", "Spinning"],
    specs: [
      ["Tallas", "Del 39 al 46"],
      ["Ajuste", "Rueda giratoria (turn buckle), se aprieta y suelta en segundos"],
      ["Suela", "Nylon antideslizante"],
      ["Exterior / interior", "Sintético / algodón"],
      ["Horma", "Ancho estándar · caña corta"],
      ["Para", "Hombre adulto"],
    ],
  },
  "0445f671-5300-4c7c-9086-956e9c920cca": {
    resumen: "Pulsera de supervivencia 6 en 1 con reloj digital, brújula, silbato, iniciador de fuego y navaja plegable integrada, tejida con paracord resistente que puedes desarmar en una emergencia. Todo en tu muñeca para camping, trekking y aventuras.",
    ideal: ["Camping y trekking", "Kit de emergencia", "Regalo para aventureros"],
    specs: [
      ["Reloj", "Digital"],
      ["Brújula", "Para ubicarte en el camino"],
      ["Silbato", "Para avisos de emergencia"],
      ["Iniciador de fuego", "Pedernal para encender fogatas"],
      ["Navaja", "Plegable, integrada en el broche"],
      ["Cuerda", "Paracord tejido, se desarma para usarla en emergencias"],
      ["Colores", "Negro, verde militar y camuflaje"],
    ],
  },
  "lentes-ciclismo": {
    resumen: "Lentes deportivos con 5 micas intercambiables para cualquier luz: polarizada gris para sol fuerte, transparente para días nublados y amarilla para poca luz o de noche. Las micas se cambian en segundos, sin desarmar los lentes. Ligeros, con armazón sin marco abajo para una vista más amplia.",
    ideal: ["Ciclismo de ruta y montaña", "Correr y manejar", "Pesca y actividades al aire libre"],
    specs: [
      ["Micas", "5 intercambiables (incluye gris polarizada, transparente HD y amarilla)"],
      ["Mica gris polarizada", "Sol fuerte: bici, manejo, golf · reduce reflejos"],
      ["Mica transparente", "Días nublados y poca luz, visión clara"],
      ["Mica amarilla", "De noche o en lugares oscuros, mejora el contraste"],
      ["Cambio de mica", "En un paso: se jala desde la nariz y los lados, sin desarmar el lente"],
      ["Diseño", "Ligero, deportivo y con armazón sin marco abajo para más campo de visión"],
      ["Incluye", "Armazón, 5 micas, estuche, paño de limpieza grande y correa para colgar"],
    ],
  },
  "80a35343-ce88-40bd-acb7-c5afe35535c8": {
    resumen: "GPS de mano Garmin con pilas AA que duran hasta 168 horas. Usa 5 sistemas de satélites para ubicarte con precisión, incluso en bosque cerrado o entre montañas, sin señal de celular.",
    ideal: ["Senderismo y montaña", "Pesca y caza", "Expediciones largas"],
    specs: [
      ["Pantalla", '2.2" monocromática de alto contraste, 240 × 320 px'],
      ["Satélites", "GPS, GLONASS, Galileo, BeiDou y QZSS"],
      ["Batería", "2 pilas AA · hasta 168 h (1,800 h en modo expedición)"],
      ["Brújula", "Electrónica"],
      ["Resistencia", "Contra agua (IPX7)"],
      ["Memoria", "1,000 puntos guardados · 200 actividades · 50 rutas"],
      ["Conexión", "Bluetooth · USB-C"],
      ["Mapa", "Mapa base con ciudades"],
      ["Tamaño", "6.1 × 10 × 3.3 cm"],
      ["Peso", "156 g con pilas"],
    ],
  },
  "c19ac8d0-ee2f-4b59-af10-d8f2945b91e4": {
    resumen: "Audífonos inalámbricos JBL con cancelación de ruido y hasta 40 horas de batería con el estuche. Resisten sudor, lluvia y polvo.",
    ideal: ["Gimnasio y correr", "Viajes", "Llamadas"],
    specs: [
      ["Cancelación de ruido", "Activa (ANC) con modo ambiente"],
      ["Batería", "Hasta 10 h en los audífonos (8 h con ANC) · 40 h en total con el estuche"],
      ["Carga rápida", "10 min = 3 h de música · USB-C"],
      ["Resistencia", "Agua y polvo (IP54)"],
      ["Bluetooth", "5.3 · conecta 2 dispositivos a la vez"],
      ["Sonido", "Bocinas de 8 mm"],
      ["Micrófonos", "4 (2 por audífono) para llamadas claras"],
      ["App", "JBL Headphones (ecualizador)"],
      ["Peso", "4.5 g cada audífono"],
    ],
  },
  "317cd3b9-c0ad-47d7-94c3-ea50d965f7c3": {
    resumen: "Batería portátil de 299 Wh y 500 W con contactos de casa, USB y DC. Mantiene funcionando tu TV de hasta 32\", ventiladores, módem, laptop, luces y electrodomésticos pequeños cuando se va la luz o en el camping. Se recarga en la pared o con panel solar, y no hace ruido ni humo como una planta de gasolina.",
    ideal: ["Apagones en casa", "Camping y viajes", "Home office sin luz"],
    specs: [
      ["Marca", "Mkimuy"],
      ["Capacidad", "299 Wh"],
      ["Potencia", "500 W continuos"],
      ["Salidas", "Contactos de corriente (127 V), USB y DC (12 V)"],
      ["Funciona con", "TV de hasta 32\", ventiladores, módem/router, laptop, celulares, focos LED, bocinas y electrodomésticos pequeños de hasta 500 W"],
      ["TV de 32\" (≈40 W)", "Aprox. 6 horas"],
      ["Ventilador (≈50 W)", "Aprox. 5 horas"],
      ["Módem / router (≈10 W)", "Aprox. 24 horas"],
      ["Foco LED (≈10 W)", "Aprox. 25 horas"],
      ["Laptop", "Aprox. 3 a 4 cargas"],
      ["Celular", "Aprox. 15 cargas"],
      ["No es para", "Microondas, plancha, secadora de pelo, cafetera o parrilla eléctrica (gastan más de 500 W)"],
      ["Carga", "Corriente de pared (110-120 V) o panel solar"],
      ["Tecnología", "Inversor · silenciosa, sin gasolina ni humo, se puede usar dentro de casa"],
      ["Encendido", "Con un solo botón"],
    ],
  },
  "fdaddfd6-c7d8-4665-9318-96de7dc2748b": {
    resumen: "Casco ligero de 200 g con visera desmontable y ventilación en toda la parte de arriba. Se ajusta con una mano para quedar firme en ruta, montaña o ciudad.",
    ideal: ["Montaña (MTB)", "Ruta y ciudad", "Patinaje"],
    specs: [
      ["Protección", "Carcasa rígida y espuma EPS que absorbe impactos"],
      ["Talla", "Ajustable de 57 a 62 cm (adulto)"],
      ["Ajuste", "Regulador trasero de una mano y correas ajustables"],
      ["Peso", "200 g"],
      ["Ventilación", "Múltiples orificios para que no se acumule el sudor"],
      ["Visera", "Incluida y desmontable, contra sol y salpicaduras"],
      ["Color", "Negro carbono"],
    ],
  },
  "af372e0c-308b-4a3d-9437-66961af608a7": {
    resumen: "La estación de energía premium de EcoFlow: se carga al 100% en solo 1 hora, aguanta hasta 1,200 W con X-Boost y su batería LiFePO4 dura unos 3,000 ciclos (más de 10 años de uso). Si se va la luz, cambia a batería en menos de 10 milisegundos, así tu computadora, módem o TV ni se apagan. Silenciosa y controlable desde el celular.",
    ideal: ["Apagones en casa y home office", "Camping y viajes en auto", "Equipo que no puede apagarse (módem, PC)"],
    specs: [
      ["Marca", "EcoFlow (marca líder en estaciones de energía)"],
      ["Capacidad", "286 Wh · ampliable a 572 Wh u 858 Wh con batería extra"],
      ["Potencia", "600 W continuos · hasta 1,200 W con X-Boost"],
      ["Batería", "LiFePO4 · 3,000 ciclos al 80% (más de 10 años de uso)"],
      ["Carga en pared", "0 a 100% en 1 hora"],
      ["Carga solar", "Hasta 220 W · llena en 1.5 h con buen sol"],
      ["Respaldo automático (UPS)", "Cambia a batería en menos de 10 ms si se va la luz"],
      ["Salidas", "3 contactos de corriente · 1 USB-C de 100 W · 2 USB-A · 1 para auto (12 V)"],
      ["Funciona con", "TV, ventiladores, módem, computadora, licuadora, luces y electrodomésticos de hasta 600 W"],
      ["TV de 32\" (≈40 W)", "Aprox. 6 horas"],
      ["Módem / router (≈10 W)", "Aprox. 24 horas"],
      ["Laptop", "Aprox. 4 cargas"],
      ["Celular", "Aprox. 20 cargas"],
      ["Ruido", "Menos de 30 dB (casi no se escucha)"],
      ["App", "EcoFlow para iPhone y Android (Wi-Fi y Bluetooth)"],
      ["Tamaño / peso", "23.4 × 23.1 × 14.7 cm · 4.7 kg"],
    ],
  },
  "remo": {
    resumen: "Par de remos de aluminio, ligeros y ajustables, para kayak, bote o lancha.",
    ideal: ["Kayak", "Bote o lancha", "Remo de repuesto"],
    specs: [
      ["Contenido", "2 remos"],
      ["Material", "Aluminio y plástico"],
      ["Largo", "1.45 m"],
      ["Diámetro del mango", "3 cm"],
      ["Ajustable", "Sí"],
    ],
  },
  "kayak-3": {
    resumen: "Kayak sit-on-top de 10 pies de la marca Lifetime: estable, resistente y fácil de llevar. Ideal para empezar a remar o pescar.",
    ideal: ["Pesca y recreo", "Mar, lago o río tranquilo", "1 persona"],
    specs: [
      ["Marca", "Lifetime"],
      ["Tipo", "Sit-on-top (te sientas encima)"],
      ["Largo", "3.05 m (10')"],
      ["Ancho", "79 cm"],
      ["Peso", "22.7 kg"],
      ["Capacidad", "Hasta 125 kg"],
      ["Material", "Polietileno de alta densidad (HDPE)"],
      ["Asiento", "1 persona, con respaldo ajustable"],
      ["Almacenamiento", "Áreas delantera y trasera con elásticos"],
      ["Drenaje", "Orificios autodrenantes"],
      ["Color", "Camo rojo"],
      ["Incluye", "Solo el kayak (remo y chaleco se venden por separado)"],
    ],
  },
  "0302ce7f-061d-4c30-8e85-a0059db4fc90": {
    resumen: "Antena de internet satelital compacta con Wi-Fi integrado. Cabe en una mochila y te da internet de alta velocidad en el campo, la playa, la carretera o en lancha.",
    ideal: ["Viajes y camping", "Casas de campo sin internet", "Lanchas y vehículos"],
    specs: [
      ["Velocidad", "Más de 100 Mbps"],
      ["Wi-Fi", "Integrado (Wi-Fi 5) · cubre hasta 112 m² · hasta 128 dispositivos"],
      ["Consumo", "25 a 40 W"],
      ["Alimentación", "12 a 48 V · se puede conectar al auto o a una estación de energía"],
      ["Resistencia", "Agua y polvo (IP67) · de -30 °C a 50 °C"],
      ["Tamaño", "29.9 × 25.9 × 3.9 cm"],
      ["Peso", "1.1 kg"],
      ["Incluye", "Antena Starlink Mini, base, soporte para tubo, cable de 15 m y fuente de poder"],
      ["Importante", "Requiere un plan de servicio Starlink, que se contrata aparte"],
    ],
  },
  "830779b5-6154-4d4c-9c06-d9aca5d31267": {
    resumen: "Audífonos Bluetooth que se instalan dentro del casco para escuchar música, contestar llamadas y seguir el GPS sin quitarte el casco. Resisten lluvia.",
    ideal: ["Moto", "Bicicleta", "Llamadas y GPS en ruta"],
    specs: [
      ["Marca", "Kazome"],
      ["Bluetooth", "5.3"],
      ["Batería", "1,000 mAh · hasta 30 h"],
      ["Resistencia", "Contra agua (IPX6)"],
      ["Llamadas", "Con reducción de ruido"],
      ["Alcance", "Hasta 20 m del celular"],
      ["Compatible", "Android y iPhone"],
    ],
  },
  "c126feba-a851-4b16-9073-915ef1bd9840": {
    resumen: "Panel solar plegable de 120 W para cargar tu estación de energía o tus equipos con la luz del sol. Se dobla para guardarlo y llevarlo a cualquier lado.",
    ideal: ["Camping", "Recargar estaciones de energía", "Lugares sin luz"],
    specs: [
      ["Marca", "Ogori"],
      ["Potencia", "120 W"],
      ["Tipo", "Monocristalino"],
      ["Eficiencia", "24%"],
      ["Diseño", "Plegable y portátil"],
      ["Resistencia", "Contra agua"],
    ],
  },
};
